import { useSyncExternalStore } from "react";
import { Award, Crown, Gem } from "lucide-react";
import { api } from "@/lib/api";

export const TIERS = {
  gold: { label: "Gold", icon: Award, text: "Reines Gold mit Schimmer" },
  platin: { label: "Platin", icon: Crown, text: "Perlmutt, Silber & Rosé" },
  diamant: { label: "Diamant", icon: Gem, text: "Funkelndes Eisblau" },
};
export const tierOf = (t) => (TIERS[t] ? t : "gold");

let map = {};
let loaded = false;
const subs = new Set();

export const refreshHonor = () => api.get("/honor/ids").then(({ data }) => { map = data || {}; subs.forEach((f) => f()); });
const load = () => {
  if (loaded) return;
  loaded = true;
  refreshHonor().catch(() => { loaded = false; });
  setInterval(() => document.visibilityState === "visible" && refreshHonor().catch(() => {}), 5 * 60 * 1000);
};

const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };

export const useHonorTitle = (id) => useSyncExternalStore(subscribe, () => (id && map[id]?.title) || null);
export const useHonorTier = (id) => useSyncExternalStore(subscribe, () => (id && map[id] ? tierOf(map[id].tier) : null));
